import React, { useState } from "react";
import "./Quote.css";
import { quoteContent } from "../../data/content";

import quoteCollage from "../../assets/images/sec4.png";
import quoteArabicImg from "../../assets/images/qoute.png";

const Quote = () => {
  const [showQuote, setShowQuote] = useState(false);

  return (
    <section
      id="quote"
      className={`quote ${showQuote ? "show" : ""}`}
      onMouseEnter={() => setShowQuote(true)}
    >
      <div className="quote-left">
        <img
          src={quoteCollage}
          alt="Fairuz collage"
          className="quote-collage"
        />
      </div>

      <div className="quote-right">
        <img
          src={quoteArabicImg}
          alt="Arabic quote"
          className="quote-arabic-image"
        />

        <p className="quote-english">{quoteContent.english}</p>
      </div>
    </section>
  );
};

export default Quote;